import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { LANGUAGES } from "constants/index";
import EarthIcon from "../../../../../assets/images/global.png";
const LanguageModal = ({ currentYear }) => {
  const { t, i18n } = useTranslation();
  const [show, setShow] = useState(false);
  const [loadingLang, setLoadingLang] = useState("");
  const [selectedLang, setSelectedLang] = useState(i18n.language);

  const changeLanguage = (lng) => {
    setLoadingLang(lng);
    setTimeout(() => {
      i18n.changeLanguage(lng);
      setSelectedLang(lng);
      setLoadingLang("");
    }, 700);
  };

  return (
    <div className="language-wrap d-flex justify-content-between align-items-center">
      <p className="mb-0">© {currentYear} NextGen Bets. All rights reserved.</p>

      <button
        className="btn btn-dark shadow-none d-flex align-items-center rounded-pill px-3 py-2"
        onClick={() => setShow(true)}
      >
        <img
          src={EarthIcon}
          alt="Earth"
          height="15"
          width="15"
          className="me-2"
        />
        {t(i18n.language)}
      </button>

      {/* Modal */}
      {show && (
        <div className="language-modal-overlay">
          <div className="language-modal">
            <div className="modal-header">
              <h5 className="modal-title">
                {t("select_language") || "Select Language"}
              </h5>
              <button
                type="button"
                className="close-btn"
                onClick={() => setShow(false)}
                disabled={loadingLang !== ""}
              >
                ✕
              </button>
            </div>
            <div className="modal-body">
              {LANGUAGES.map((lang) => {
                const label = t(lang.label.toLowerCase()) || lang.label;
                const capitalizedLabel =
                  label.charAt(0).toUpperCase() + label.slice(1);

                return (
                  <button
                    key={lang.languageCode}
                    className={`lang-item ${
                      selectedLang === lang.languageCode ? "active" : ""
                    }`}
                    onClick={() => changeLanguage(lang.languageCode)}
                    disabled={loadingLang !== ""}
                  >
                    <span>{capitalizedLabel}</span>
                    <span className="icons">
                      {loadingLang === lang.languageCode && (
                        <i className="fas fa-spinner fa-spin"></i>
                      )}
                      {selectedLang === lang.languageCode &&
                        loadingLang === "" && (
                          <i className="fas fa-check text-success"></i>
                        )}
                    </span>
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      )}

      {/* CSS */}
      <style jsx>{`
        .language-modal-overlay {
          position: fixed;
          inset: 0;
          background: rgba(0, 0, 0, 0.55);
          backdrop-filter: blur(6px);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1050;
        }

        .language-modal {
          background: #1c1c26;
          border: 1px solid rgba(255, 255, 255, 0.1);
          border-radius: 12px;
          width: 320px;
          padding: 16px;
          color: #fff;
          box-shadow: 0 6px 24px rgba(0, 0, 0, 0.6);
        }

        .modal-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 12px;
        }

        .modal-title {
          font-weight: 600;
          font-size: 16px;
          color: #f5f5f5;
        }

        .close-btn {
          background: transparent;
          border: none;
          font-size: 18px;
          color: #aaa;
          cursor: pointer;
          transition: color 0.2s ease-in-out;
        }

        .close-btn:hover {
          color: #fff;
        }

        .modal-body {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }

        .lang-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: transparent;
          border: 1px solid rgba(255, 255, 255, 0.2);
          border-radius: 8px;
          padding: 10px 14px;
          font-size: 14px;
          color: #ddd;
          transition: all 0.2s ease-in-out;
          cursor: pointer;
        }

        .lang-item:hover {
          border-color: #0d6efd;
          color: #fff;
        }

        .lang-item.active {
          border: 1px solid #0d6efd;
          background: rgba(13, 110, 253, 0.1);
          color: #fff;
        }

        .icons {
          display: flex;
          align-items: center;
          gap: 6px;
        }
      `}</style>
    </div>
  );
};

export default React.memo(LanguageModal);
